var map = {
	"./action.js": "44d0",
	"./app.js": "dbf9",
	"./business.js": "e504",
	"./channel.js": "846b",
	"./currency.js": "8175",
	"./notice.js": "9f38",
	"./product.js": "6e2e",
	"./swap.js": "99b4",
	"./system.js": "4292"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b923";